import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useStyles from './Banner.styles';
import { Box } from '@mui/material';
import useCommonStyles from '../../styles/jss/common';
import { getContentPositionClass, getMinHeightClass } from '../../utils/common';
import { useTextColor } from '../../styles/jss/utils';
import clsx from 'clsx';
import GenericImage from '../GenericImage/GenericImage';
import Content from '../Content/Content';
/**
 * Banner - Design System v2.10.2 - Molecules / Promos
 *
 * * Slim promo with image bg: m-promo_fullwidth_slim_text-on-image
 */
const Banner = (props) => {
    var _a, _b;
    const { minHeight = 'MEDIUM', headingTag = 'H3', backgroundColour, contentPosition, image } = props;
    const { classes } = useStyles({ links: (_a = props === null || props === void 0 ? void 0 : props.links) === null || _a === void 0 ? void 0 : _a.length });
    const { classes: commonClasses } = useCommonStyles({});
    // Always call hooks unconditionally
    const { textColor, backgroundColor } = useTextColor((_b = backgroundColour === null || backgroundColour === void 0 ? void 0 : backgroundColour[0]) === null || _b === void 0 ? void 0 : _b.backgroundColour);
    const contentPositionClass = getContentPositionClass(contentPosition, {
        positionLeft: classes.positionLeft,
        positionCenter: classes.positionCenter,
        positionRight: classes.positionRight,
    });
    const minHeightClass = getMinHeightClass(minHeight, {
        minHeightLarge: commonClasses.minHeightLarge,
        minHeightMedium: commonClasses.minHeightMedium,
        minHeightSmall: commonClasses.minHeightSmall,
        minHeightBlog: commonClasses.minHeightBlog,
    });
    return (_jsxs(Box, { className: clsx(classes.container, contentPositionClass, minHeightClass), "data-testid": "banner", style: { backgroundColor, color: textColor }, children: [_jsx(GenericImage, Object.assign({}, props, { fullWidthImage: true, renderSquareImage: true, renderSquaredImagesOptions: true, classNames: [commonClasses.image, classes.bannerImage], backgroundColour: backgroundColor, showImageSpacer: !!(image === null || image === void 0 ? void 0 : image.url) })), _jsx(Content, Object.assign({}, props, { headingTag: headingTag, wrapText: false, containerClasses: [classes.content], headingClasses: [classes.heading], linkStyle: "BUTTON", linkContainerClasses: [classes.linkContainer], linkClassNames: [classes.link], textAlignment: "LEFT", messageClasses: [classes.message], contentInnerClasses: [classes.contentInner] }))] }));
};
export default Banner;
